export default __webpack_public_path__ + "static/3-dystopia-3851941f06123fdd583e4e3642c6d166.png";